import { Bot, User } from 'lucide-react';
import { useGuidanceHistory } from '../api/queries.js';
import { DISMISSAL_REASON_LABEL, HISTORY_ACTION_LABEL, formatDateTime } from './labels.js';

/** The change log of one guidance (functional §8.4): author, date, action, oldest first. */
export function GuidanceHistory({ guidanceId }: { guidanceId: string }) {
  const { data, isLoading, isError } = useGuidanceHistory(guidanceId);

  if (isLoading) return <p className="history__empty">Chargement du journal…</p>;
  if (isError || !data) return <p className="history__empty">Le journal n'a pas pu être chargé.</p>;

  return (
    <ol className="history" data-testid="guidance-history">
      {data.map((entry) => (
        <li key={`${entry.action}-${entry.occurredAt}`} className="history__entry">
          <span className="history__icon" aria-hidden>
            {entry.actorId ? <User size={12} /> : <Bot size={12} />}
          </span>
          <span className="history__text">
            <strong>{HISTORY_ACTION_LABEL[entry.action]}</strong>
            {detail(entry.action, entry.metadata)}
            <span className="history__meta">
              {entry.actorName ?? (entry.actorId ? 'Compte inconnu' : "Moteur d'analyse")} ·{' '}
              <time dateTime={entry.occurredAt}>{formatDateTime(entry.occurredAt)}</time>
            </span>
          </span>
        </li>
      ))}
    </ol>
  );
}

function detail(action: string, metadata: Record<string, string | number | boolean> | null): string {
  if (!metadata) return '';
  if (action === 'guidance.published' && typeof metadata.configurationVersion === 'number') {
    return ` · configuration v${metadata.configurationVersion}`;
  }
  if (action === 'guidance.dismissed' && typeof metadata.reason === 'string') {
    const reason = metadata.reason as keyof typeof DISMISSAL_REASON_LABEL;
    return ` · ${DISMISSAL_REASON_LABEL[reason] ?? metadata.reason}`;
  }
  if (action === 'guidance.proposed' && metadata.contentGenerationSkipped === true) {
    return ' · sans texte rédigé (modèle indisponible)';
  }
  if (action === 'guidance.approved' && metadata.adjusted === true) return ' · après ajustement';
  return '';
}
